import script from "./BssMapVehicleInfobox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMapVehicleInfobox.vue?vue&type=script&lang=ts&setup=true"

import "./BssMapVehicleInfobox.vue?vue&type=style&index=0&id=393fac84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393fac84"]])

export default __exports__